import {
  CreateParams,
  DeleteParams,
  GetListParams,
  GetManyParams,
  GetOneParams,
  UpdateParams,
} from 'ra-core';

import { api } from '../../api';
import {
  CreateOneCategoryDto,
  UpdateOneCategoryDto,
} from '../../api/generated';
import { Params } from '../../types';
import { nestQueryBuilder } from '../../utils/queryBuilder';
import { uploadFile } from '../../utils/uploadFile';
import { RouteDataProvider } from '../types';

// @ts-ignore
export const categoriesProvider = {
  async create(params: CreateParams<CreateOneCategoryDto>) {
    let iconUrl;

    try {
      //@ts-ignore
      if (params.data.iconUrl.rawFile) {
        //@ts-ignore
        iconUrl = await uploadFile(params.data.iconUrl.rawFile);
      } else {
        iconUrl = params.data.iconUrl;
      }
    } catch (e) {
      return Promise.reject('Не удалось загрузить иконку');
    }

    try {
      const { data } =
        await api.V1AdminCategoriesApi.adminCategoriesControllerCreateOne({
          ...params.data,
          ...(!params.data.rootCategoryId && {
            rubricsIds: params.data.rubricsIds?.length
              ? params.data.rubricsIds
              : undefined,
          }),
          ...(!params.data.rubricsIds?.length && {
            rootCategoryId: params.data.rootCategoryId
              ? params.data.rootCategoryId
              : undefined,
          }),
          iconUrl: iconUrl,
        });

      return {
        data: data,
      };
    } catch (e) {
      return Promise.reject('Не удалось создать категорию');
    }
  },

  async getList(params: GetListParams) {
    const query = nestQueryBuilder(params);
    const reqParams: Params = {
      page: params.pagination.page,
      limit: params.pagination.perPage,
      sort: query.getAll('sort'),
      filter: query.getAll('filter'),
      join: ['rubrics', 'rootCategory'],
    };
    const { data }: any =
      await api.V1AdminCategoriesApi.getManyBaseAdminCategoriesControllerCategory(
        reqParams.fields,
        reqParams.s,
        reqParams.filter,
        reqParams.or,
        reqParams.sort,
        reqParams.join,
        reqParams.limit,
        reqParams.offset,
        reqParams.page,
        reqParams.cache,
        reqParams.options
      );

    return {
      data: data.data,
      total: data.total,
    };
  },

  async getMany(params: GetManyParams) {
    const reqParams: Params = {
      join: ['rubrics', 'rootCategory'],
    };
    const customRequests = [];
    for (let i = 0; i < params.ids.length; i++) {
      const id = params.ids[i];
      if (typeof id === 'number') {
        try {
          const { data: customRequest } =
            await api.V1AdminCategoriesApi.getOneBaseAdminCategoriesControllerCategory(
              id,
              reqParams.fields,
              reqParams.join
            );
          customRequests.push(customRequest);
        } catch (e) {
          customRequests.push({});
        }
      }
    }
    return { data: customRequests };
  },

  async getOne(params: GetOneParams) {
    const reqParams: Params = {
      join: ['rubrics', 'rootCategory'],
    };

    const { data: customRequest } =
      await api.V1AdminCategoriesApi.getOneBaseAdminCategoriesControllerCategory(
        parseInt(params.id.toString()),
        reqParams.fields,
        reqParams.join
      );

    return {
      data: customRequest,
    };
  },

  async update(params: UpdateParams<UpdateOneCategoryDto>) {
    let iconUrl;

    try {
      //@ts-ignore
      if (params.data.iconUrl.rawFile) {
        //@ts-ignore
        iconUrl = await uploadFile(params.data.iconUrl.rawFile);
      } else {
        iconUrl = params.data.iconUrl;
      }
    } catch (e) {
      return Promise.reject('Не удалось загрузить иконку');
    }

    try {
      const { data: customRequest } =
        await api.V1AdminCategoriesApi.updateOneBaseAdminCategoriesControllerCategory(
          parseInt(params.id as string),
          {
            ...params.data,
            iconUrl: iconUrl,
          }
        );
      return {
        data: customRequest,
      };
    } catch (e) {
      return Promise.reject('Не удалось обновить категорию');
    }
  },

  async delete(params: DeleteParams) {
    const id = params.id;
    if (typeof id === 'number') {
      const { data: customRequest } =
        await api.V1AdminCategoriesApi.getOneBaseAdminCategoriesControllerCategory(
          id
        );
      const { status } =
        await api.V1AdminCategoriesApi.deleteOneBaseAdminCategoriesControllerCategory(
          id
        );
      if (status === 200) {
        return { data: customRequest };
      }
    }
    return Promise.reject({ data: params.previousData });
  },
} as RouteDataProvider;
